// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table{width:100%;border-collapse:collapse}table tr:nth-child(even){background-color:#f1f5f7}`, "",{"version":3,"sources":["webpack://./src/components/allWorkTools/table/Table.module.scss"],"names":[],"mappings":"AAAA,MACE,UAAA,CACA,wBAAA,CACA,yBACE,wBAAA","sourcesContent":["table {\n  width: 100%;\n  border-collapse: collapse;\n  tr:nth-child(even) {\n    background-color: #F1F5F7;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
